import { PinataSDK } from "pinata";
import { KEYSERVER_URL } from "./Client";
import { StoredMetadata } from "./Metadata";

export interface Storage {
  upload(data: StoredMetadata): Promise<string>;
}

export class KeyserverStorage implements Storage {
  public async upload(data: StoredMetadata): Promise<string> {
    const res = await fetch(`${KEYSERVER_URL}/storage/fs`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    });
    const json = await res.json();
    return json.url;
  }
}

export class S3Storage implements Storage {
  public async upload(data: StoredMetadata): Promise<string> {
    const res = await fetch(`${KEYSERVER_URL}/storage/s3`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    });
    const json = await res.json();
    return json.url;
  }
}

export interface IpfsSettings {
  pinata: boolean;
  pinata_jwt?: string;
  pinata_gateway?: string;
}

export class IpfsStorage implements Storage {
  private settings: IpfsSettings;

  constructor(settings: IpfsSettings) {
    this.settings = settings;
  }

  public async upload(data: StoredMetadata): Promise<string> {
    // Ensure Pinata is enabled
    if (!this.settings.pinata) {
      throw new Error("No pinning service enabled");
    }

    // Initialize Pinata Web3 SDK client
    const pinata = new PinataSDK({
      pinataJwt:     this.settings.pinata_jwt!,
      pinataGateway: this.settings.pinata_gateway,
    });

    // Upload JSON data to Pinata
    const uploadResult = await pinata.upload.public.json(data);
    const cid = uploadResult.cid;

    // Verify CID was returned
    if (!cid) {
      throw new Error("Pinata upload failed: no CID returned");
    }

    return `ipfs://${cid}`;
  }
}
